module.exports = __webpack_public_path__ + "static/media/CoM_Secondary_A_black.8413ef2e.png";